import system from 'system-components'

const Img = system({
  is: 'img',
  mx: [0, -5],
  mt: 6,
  mb: 5,
  width: ['100%', '104%']
})

export default Img
